type Props = { height?: string };

const TextTrimmer: FC<Props> = ({ children, height }) => (
  <div
    className="line-clamp-1"
    style={{
      height,
    }}
  >
    {children}
  </div>
);

export default TextTrimmer;
